// To use
// import { materials, jobTypes, karigars } from './dummyProductionData';

// Sample data for materials
export const materials = [
  {
    id: 1,
    name: "Cotton Fabric",
    colors: "White, Black",
    unit: "meters",
    avgPrice: 150,
    image:
      "https://images.unsplash.com/photo-1518893063132-36e46dbe2428?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    supplier: "Supplier A",
    inStock: 500,
    reorderPoint: 100,
  },
  {
    id: 2,
    name: "Silk Fabric",
    colors: "Red, Blue",
    unit: "meters",
    avgPrice: 300,
    image:
      "https://images.unsplash.com/photo-1518893063132-36e46dbe2428?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    supplier: "Supplier B",
    inStock: 300,
    reorderPoint: 50,
  },
  {
    id: 3,
    name: "Polyester",
    colors: "Multiple",
    unit: "meters",
    avgPrice: 120,
    image:
      "https://images.unsplash.com/photo-1518893063132-36e46dbe2428?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    supplier: "Supplier C",
    inStock: 800,
    reorderPoint: 150,
  },
  {
    id: 4,
    name: "Linen",
    colors: "White, Beige",
    unit: "meters",
    avgPrice: 250,
    image:
      "https://images.unsplash.com/photo-1518893063132-36e46dbe2428?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    supplier: "Supplier A",
    inStock: 400,
    reorderPoint: 80,
  },
  {
    id: 5,
    name: "Denim",
    colors: "Blue, Black",
    unit: "meters",
    avgPrice: 180,
    image:
      "https://images.unsplash.com/photo-1518893063132-36e46dbe2428?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    supplier: "Supplier D",
    inStock: 600,
    reorderPoint: 120,
  },
];

// Sample data for job types
export const jobTypes = [
  { id: 1, name: "Cutting", rate: 50 },
  { id: 2, name: "Stitching", rate: 100 },
  { id: 3, name: "Embroidery", rate: 150 },
  { id: 4, name: "Printing", rate: 80 },
  { id: 5, name: "Washing", rate: 40 },
  { id: 6, name: "Packaging", rate: 30 },
];

// Sample data for karigars (workers)
export const karigars = [
  {
    id: 1,
    name: "John Doe",
    specialization: "Cutting",
    experience: "5 years",
    rating: 4.5,
    contactNo: "+91 9876543210",
    address: "123, Worker Colony, City",
  },
  {
    id: 2,
    name: "Jane Smith",
    specialization: "Stitching",
    experience: "8 years",
    rating: 4.8,
    contactNo: "+91 9876543211",
    address: "456, Worker Colony, City",
  },
  {
    id: 3,
    name: "Mike Wilson",
    specialization: "Embroidery",
    experience: "6 years",
    rating: 4.2,
    contactNo: "+91 9876543212",
    address: "789, Worker Colony, City",
  },
  {
    id: 4,
    name: "Sarah Johnson",
    specialization: "Printing",
    experience: "4 years",
    rating: 4.0,
    contactNo: "+91 9876543213",
    address: "101, Worker Colony, City",
  },
  {
    id: 5,
    name: "David Brown",
    specialization: "Washing",
    experience: "3 years",
    rating: 4.3,
    contactNo: "+91 9876543214",
    address: "202, Worker Colony, City",
  },
];

// Sample data for product sections
export const sections = [
  { id: "bottom", label: "Bottom", defaultRate: 100 },
  { id: "dupatta", label: "Dupatta", defaultRate: 50 },
  { id: "fabric", label: "Fabric", defaultRate: 200 },
  { id: "kurti", label: "Kurti", defaultRate: 150 },
  { id: "pent", label: "Pent", defaultRate: 120 },
  { id: "top", label: "Top", defaultRate: 130 },
  { id: "otherCosts", label: "Other Costs", defaultRate: 0 },
];

// Sample data for units
export const units = [
  { id: "meters", label: "Meters", shortForm: "m" },
  { id: "pieces", label: "Pieces", shortForm: "pcs" },
  { id: "kg", label: "Kilograms", shortForm: "kg" },
  { id: "grams", label: "Grams", shortForm: "g" },
  { id: "yards", label: "Yards", shortForm: "yd" },
  { id: "sets", label: "Sets", shortForm: "sets" },
];

// Sample data for suppliers
export const suppliers = [
  {
    id: 1,
    name: "Supplier A",
    contactPerson: "John Smith",
    phone: "+91 9876543215",
    email: "suppliera@example.com",
    address: "123, Supplier Street, City",
    rating: 4.5,
  },
  {
    id: 2,
    name: "Supplier B",
    contactPerson: "Mary Johnson",
    phone: "+91 9876543216",
    email: "supplierb@example.com",
    address: "456, Supplier Street, City",
    rating: 4.2,
  },
  {
    id: 3,
    name: "Supplier C",
    contactPerson: "Robert Wilson",
    phone: "+91 9876543217",
    email: "supplierc@example.com",
    address: "789, Supplier Street, City",
    rating: 4.7,
  },
  {
    id: 4,
    name: "Supplier D",
    contactPerson: "Sarah Brown",
    phone: "+91 9876543218",
    email: "supplierd@example.com",
    address: "101, Supplier Street, City",
    rating: 4.0,
  },
  {
    id: 5,
    name: "Local Market",
    contactPerson: "Various Vendors",
    phone: "Multiple",
    email: "localmarket@example.com",
    address: "Local Market Area, City",
    rating: 3.8,
  },
];

// Sample data for colors
export const colors = [
  { id: 1, name: "Red", hexCode: "#FF0000" },
  { id: 2, name: "Blue", hexCode: "#0000FF" },
  { id: 3, name: "Green", hexCode: "#00FF00" },
  { id: 4, name: "Black", hexCode: "#000000" },
  { id: 5, name: "White", hexCode: "#FFFFFF" },
  { id: 6, name: "Yellow", hexCode: "#FFFF00" },
  { id: 7, name: "Purple", hexCode: "#800080" },
  { id: 8, name: "Orange", hexCode: "#FFA500" },
];

// Sample data for sizes
export const sizes = [
  { id: "XS", label: "XS", order: 1 },
  { id: "S", label: "S", order: 2 },
  { id: "M", label: "M", order: 3 },
  { id: "L", label: "L", order: 4 },
  { id: "XL", label: "XL", order: 5 },
  { id: "2XL", label: "2XL", order: 6 },
  { id: "3XL", label: "3XL", order: 7 },
  { id: "4XL", label: "4XL", order: 8 },
];

// Sample data for designs
export const designs = [
  {
    id: 1,
    name: "Floral Pattern Dress",
    designId: "DSG001",
    image:
      "https://images.unsplash.com/photo-1518893063132-36e46dbe2428?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    createdAt: "2024-03-15",
    description: "A beautiful floral pattern for summer dresses",
    category: "Dresses",
    designer: "Jane Smith",
    pieces: [
      {
        pieceType: "Top",
        colors: [
          {
            name: "Red",
            sizes: {
              S: 50,
              M: 75,
              L: 60,
              XL: 40,
            },
          },
          {
            name: "Blue",
            sizes: {
              S: 40,
              M: 60,
              L: 45,
              XL: 30,
            },
          },
        ],
      },
      {
        pieceType: "Bottom",
        colors: [
          {
            name: "White",
            sizes: {
              S: 50,
              M: 75,
              L: 60,
              XL: 40,
            },
          },
        ],
      },
    ],
  },
  {
    id: 2,
    name: "Classic Suit Design",
    designId: "DSG002",
    image:
      "https://images.unsplash.com/photo-1518893063132-36e46dbe2428?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    createdAt: "2024-03-14",
    description: "Traditional suit design with modern elements",
    category: "Suits",
    designer: "John Doe",
    pieces: [
      {
        pieceType: "Jacket",
        colors: [
          {
            name: "Black",
            sizes: {
              M: 40,
              L: 50,
              XL: 35,
              "2XL": 25,
            },
          },
        ],
      },
      {
        pieceType: "Pant",
        colors: [
          {
            name: "Black",
            sizes: {
              M: 40,
              L: 50,
              XL: 35,
              "2XL": 25,
            },
          },
        ],
      },
    ],
  },
];

// Sample data for agents
export const agents = [
  { id: 1, name: "Direct", commission: 0 },
  { id: 2, name: "Agent 1", commission: 5 },
  { id: 3, name: "Agent 2", commission: 7 },
  { id: 4, name: "Agent 3", commission: 6 },
];

// Sample status options for various entities
export const statusOptions = {
  jobslip: ["Pending", "In Progress", "Completed", "Cancelled"],
  material: ["In Stock", "Low Stock", "Out of Stock", "Discontinued"],
  order: ["New", "Processing", "Ready", "Delivered", "Cancelled"],
  payment: ["Pending", "Partial", "Completed", "Refunded"],
};

// Sample data for common measurements
export const measurements = {
  fabric: ["Length", "Width", "GSM"],
  garment: [
    "Chest",
    "Waist",
    "Hip",
    "Shoulder",
    "Sleeve Length",
    "Total Length",
  ],
  packaging: ["Length", "Width", "Height", "Weight"],
};

// Sample data for quality parameters
export const qualityParameters = {
  fabric: ["Color Fastness", "Shrinkage", "Tear Strength", "Wash Durability"],
  stitching: [
    "Stitch Quality",
    "Seam Strength",
    "Pattern Matching",
    "Finishing",
  ],
  printing: [
    "Print Quality",
    "Color Accuracy",
    "Design Placement",
    "Wash Fastness",
  ],
};
